module.exports = __webpack_public_path__ + "static/media/dsc_7544.04d63ab4.jpg";